module.exports = __webpack_public_path__ + "img/ruwufuyi@3x.f994f747.png";